import script from "./AppleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppleButton.vue?vue&type=script&setup=true&lang=ts"

import "./AppleButton.vue?vue&type=style&index=0&id=143793a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143793a8"]])

export default __exports__